// extracted by mini-css-extract-plugin
export default {"uploadMusic":"upload-music_uploadMusic__HtDGJ","table":"upload-music_table__t3ElC"};